BaseModel = require './base_model.coffee'

class global.CvCrmSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    domain: {}
    email: {}
    add_contacts_from_cv_crm: {}
    metadata: { default: { pipeline_name: '', stage_id: '', pipeline_id: '' }, type: Object }
    triggers: { default: { on_created: false, status: ['connected'], stages: [] }, type: Object }
    properties_matching: { default: [ { reev: 'telephone', reev_name: 'Telefone', integration: 'phone', integration_name: 'Telefone', type: 'tel' } ], type: Object }
    stages_matching: { default: [], type: Object }
  }



// WEBPACK FOOTER //
// ./src/models/cv_crm_setting.coffee